import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CampaignFull, CampaignShort, E_CAMPAIGN_STATUS } from '@Interfaces/rewards.interfaces';
import { WalletListErrorComponent } from '@Modules/rewards/components/wallet-list-error/wallet-list-error.component';
import { TranslateModule } from '@ngx-translate/core';
import { GetRewardsTranslationPipe } from '@Pipes/get-rewards-translation.pipe';
import { RewardsService } from '@Services/rewards.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'active-campaign-banner',
    imports: [TranslateModule, DatePipe, AsyncPipe, RouterLink, WalletListErrorComponent, GetRewardsTranslationPipe],
    templateUrl: './active-campaign-banner.component.html',
    styleUrl: './active-campaign-banner.component.scss'
})

export class ActiveCampaignBannerComponent {

  private readonly rewardsSvc = inject(RewardsService);

  public activeCampaign$: Observable<CampaignShort | null> = this.rewardsSvc.activeCampaign$;
  public rewardSystemError = this.rewardsSvc.rewardSystemError;

  public readonly campaingInfo = input.required<CampaignFull | null>();
  public readonly linkClicked = output<void>();

  public readonly campaignStatus = this.rewardsSvc.campaignStatus;

  public readonly E_CAMPAIGN_STATUS = E_CAMPAIGN_STATUS;

  public readonly campaginPicture = computed(() => {
    const campaing = this.campaingInfo();
    if(!campaing) return null;
    const pic = campaing.images[0];
    return pic ? pic : null;
  })

  get campaignDetailsLink(){
    return `/rewards/campaign/${this.campaingInfo()?.uuid}`;
  }

}
